var DB_RelatedArticles = {
    init:function(){

        var _swiper_container = document.querySelector(".DB-related-articles .swiper-container");

        var swiper = new Swiper(_swiper_container, {
            slidesPerView: 1.2,
            spaceBetween: 20,
            
            breakpoints: {
                768: {
                slidesPerView: 2.2,
                spaceBetween: 30,
                },
                1200: {
                slidesPerView: 3,
                spaceBetween: 50,
                }
            },
        });

    }
}

window.addEventListener("load", function(){
    if(document.querySelectorAll(".DB-related-articles").length > 0){
        DB_RelatedArticles.init();
    }
})